import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FooterContent } from './FooterContent';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetAssignedToYouFooter_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type AssetAssignedToYouFooter_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type AssetAssignedToYouFooter_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type AssetAssignedToYouFooter_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', footer?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection', content: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName', content: string } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName', content: string } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp', content: string } | { __typename?: 'NotificationLayoutItemUserName' }> } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null } } };

export type AssetAssignedToYouFooter_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type AssetAssignedToYouFooter_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type AssetAssignedToYouFooter_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type AssetAssignedToYouFooter_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type AssetAssignedToYouFooter_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type AssetAssignedToYouFooter_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type AssetAssignedToYouFooter_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type AssetAssignedToYouFooter_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type AssetAssignedToYouFooter_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type AssetAssignedToYouFooter_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type AssetAssignedToYouFooter_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type AssetAssignedToYouFooter_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type AssetAssignedToYouFooter_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type AssetAssignedToYouFooterFragment = AssetAssignedToYouFooter_NotificationGroupAccessRequestApproved_Fragment | AssetAssignedToYouFooter_NotificationGroupAccessRequestDenied_Fragment | AssetAssignedToYouFooter_NotificationGroupAccessRequestSubmitted_Fragment | AssetAssignedToYouFooter_NotificationGroupAssetAssignedToYou_Fragment | AssetAssignedToYouFooter_NotificationGroupAssetStatusChanged_Fragment | AssetAssignedToYouFooter_NotificationGroupCommentCreated_Fragment | AssetAssignedToYouFooter_NotificationGroupCommentCreatedShareAccess_Fragment | AssetAssignedToYouFooter_NotificationGroupFileUploaded_Fragment | AssetAssignedToYouFooter_NotificationGroupReplyCreated_Fragment | AssetAssignedToYouFooter_NotificationGroupReplyCreatedShareAccess_Fragment | AssetAssignedToYouFooter_NotificationGroupRequesterAccessRequestApproved_Fragment | AssetAssignedToYouFooter_NotificationGroupRequesterAccessRequestDenied_Fragment | AssetAssignedToYouFooter_NotificationGroupTranscriptCompletedSelf_Fragment | AssetAssignedToYouFooter_NotificationGroupTransferBatchCompleted_Fragment | AssetAssignedToYouFooter_NotificationGroupTransferBatchCompletedSelf_Fragment | AssetAssignedToYouFooter_NotificationGroupUserMentioned_Fragment | AssetAssignedToYouFooter_NotificationGroupUserMentionedShareAccess_Fragment;

export const AssetAssignedToYouFooter = /*#__PURE__*/ gql`
    fragment AssetAssignedToYouFooter on NotificationGroup {
  ... on NotificationGroupAssetAssignedToYou {
    content {
      layout {
        ...FooterContent
      }
    }
  }
}
    ${FooterContent}` as unknown as DocumentNode<AssetAssignedToYouFooterFragment, unknown>;

        

        
export const useAssetAssignedToYouFooterFragment = (
  input: string | Omit<UseFragmentOptions<AssetAssignedToYouFooterFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<AssetAssignedToYouFooterFragment>({
    fragment: AssetAssignedToYouFooter,
    fragmentName: 'AssetAssignedToYouFooter',
    ...options,
  });
};
  
        